import moment from 'moment';
import lodashValues from 'lodash/fp/values';

import {
  SR_API_ACTION_PARTNER_GET_LISTING_TOUR_REVIEWS,
} from 'api/actionTypes';
import { hasRolesNotShowTourFeedback } from 'common/tourHelpers';

export default async function getPartnerListingTourReviews(
  { state, apiClient },
  { listingId, apartmentId, forceRefresh }
) {
  const partnerListingTourReviewsRoute = [
    'partners',
    listingId ? 'listingTourReviewsById' : 'apartmentTourReviewsById',
    listingId || apartmentId,
  ];
  if (state.get(partnerListingTourReviewsRoute) && !forceRefresh) {
    return state.get(partnerListingTourReviewsRoute);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_LISTING_TOUR_REVIEWS,
    queryId: listingId || apartmentId,
    state: state,
    payload: {
      listingId,
      apartmentId,
    },
    onSuccess(tours) {
      const filterTours = tours.filter((tour) => !hasRolesNotShowTourFeedback(tour.user?.roles || []));

      const userTours = lodashValues(filterTours.reduce((memo, tour) => {
        if (tour.supraShowingId) {
          memo[tour.supraShowingId] = {
            id: `supra-${tour.supraShowingId}`,
            tours: [
              tour,
            ],
            startDate: new Date(tour.startDate).getTime(),
          };
        }
        else {
          memo[tour.userId] = memo[tour.userId] || {
            id: tour.userId,
            tours: [],
          };
          memo[tour.userId].tours.push(tour);
          memo[tour.userId].startDate = Math.max(
            ...memo[tour.userId].tours.map((tour) => new Date(tour.startDate).getTime())
          );
        }

        return memo;
      }, {}));

      userTours.sort((tourA, tourB) => (
        moment(tourB.startDate).unix() - moment(tourA.startDate).unix()
      ));

      state.set(partnerListingTourReviewsRoute, userTours);
    },
  });
}
